export const countryOptions = [
  { code: 'AFGHANISTAN', en: 'Afghanistan', zhCN: '阿富汗', de: 'Afghanistan' },
  { code: 'ALAND_ISLANDS', en: 'Åland Islands', zhCN: '奥兰群岛', de: 'Ålandinseln' },
  { code: 'ALBANIA', en: 'Albania', zhCN: '阿尔巴尼亚', de: 'Albanien' },
  { code: 'ALGERIA', en: 'Algeria', zhCN: '阿尔及利亚', de: 'Algerien' },
  { code: 'AMERICAN_SAMOA', en: 'American Samoa', zhCN: '美属萨摩亚', de: 'Amerikanisch-Samoa' },
  { code: 'ANDORRA', en: 'Andorra', zhCN: '安道尔', de: 'Andorra' },
  { code: 'ANGOLA', en: 'Angola', zhCN: '安哥拉', de: 'Angola' },
  { code: 'ANGUILLA', en: 'Anguilla', zhCN: '安圭拉', de: 'Anguilla' },
  { code: 'ANTARCTICA', en: 'Antarctica', zhCN: '南极洲', de: 'Antarktis' },
  { code: 'ANTIGUA_AND_BARBUDA', en: 'Antigua and Barbuda', zhCN: '安提瓜和巴布达', de: 'Antigua und Barbuda' },
  { code: 'ARGENTINA', en: 'Argentina', zhCN: '阿根廷', de: 'Argentinien' },
  { code: 'ARMENIA', en: 'Armenia', zhCN: '亚美尼亚', de: 'Armenien' },
  { code: 'ARUBA', en: 'Aruba', zhCN: '阿鲁巴', de: 'Aruba' },
  { code: 'AUSTRALIA', en: 'Australia', zhCN: '澳大利亚', de: 'Australien' },
  { code: 'AUSTRIA', en: 'Austria', zhCN: '奥地利', de: 'Österreich' },
  { code: 'AZERBAIJAN', en: 'Azerbaijan', zhCN: '阿塞拜疆', de: 'Aserbaidschan' },
  { code: 'BAHAMAS', en: 'Bahamas', zhCN: '巴哈马', de: 'Bahamas' },
  { code: 'BAHRAIN', en: 'Bahrain', zhCN: '巴林', de: 'Bahrain' },
  { code: 'BANGLADESH', en: 'Bangladesh', zhCN: '孟加拉国', de: 'Bangladesch' },
  { code: 'BARBADOS', en: 'Barbados', zhCN: '巴巴多斯', de: 'Barbados' },
  { code: 'BELARUS', en: 'Belarus', zhCN: '白俄罗斯', de: 'Belarus' },
  { code: 'BELGIUM', en: 'Belgium', zhCN: '比利时', de: 'Belgien' },
  { code: 'BELIZE', en: 'Belize', zhCN: '伯利兹', de: 'Belize' },
  { code: 'BENIN', en: 'Benin', zhCN: '贝宁', de: 'Benin' },
  { code: 'BERMUDA', en: 'Bermuda', zhCN: '百慕大', de: 'Bermuda' },
  { code: 'BHUTAN', en: 'Bhutan', zhCN: '不丹', de: 'Bhutan' },
  { code: 'BOLIVIA', en: 'Bolivia', zhCN: '玻利维亚', de: 'Bolivien' },
  { code: 'BOSNIA_AND_HERZEGOVINA', en: 'Bosnia and Herzegovina', zhCN: '波黑', de: 'Bosnien und Herzegowina' },
  { code: 'BOTSWANA', en: 'Botswana', zhCN: '博茨瓦纳', de: 'Botswana' },
  { code: 'BOUVET_ISLAND', en: 'Bouvet Island', zhCN: '布韦岛', de: 'Bouvetinsel' },
  { code: 'BRAZIL', en: 'Brazil', zhCN: '巴西', de: 'Brasilien' },
  { code: 'BRITISH_INDIAN_OCEAN_TERRITORY', en: 'British Indian Ocean Territory', zhCN: '英属印度洋领地', de: 'Britisches Territorium im Indischen Ozean' },
  { code: 'BRITISH_VIRGIN_ISLANDS', en: 'British Virgin Islands', zhCN: '英属维尔京群岛', de: 'Britische Jungferninseln' },
  { code: 'BRUNEI', en: 'Brunei', zhCN: '文莱', de: 'Brunei' },
  { code: 'BULGARIA', en: 'Bulgaria', zhCN: '保加利亚', de: 'Bulgarien' },
  { code: 'BURKINA_FASO', en: 'Burkina Faso', zhCN: '布基纳法索', de: 'Burkina Faso' },
  { code: 'BURUNDI', en: 'Burundi', zhCN: '布隆迪', de: 'Burundi' },
  { code: 'CAMBODIA', en: 'Cambodia', zhCN: '柬埔寨', de: 'Kambodscha' },
  { code: 'CAMEROON', en: 'Cameroon', zhCN: '喀麦隆', de: 'Kamerun' },
  { code: 'CANADA', en: 'Canada', zhCN: '加拿大', de: 'Kanada' },
  { code: 'CAPE_VERDE', en: 'Cape Verde', zhCN: '佛得角', de: 'Kap Verde' },
  { code: 'CARIBBEAN_NETHERLANDS', en: 'Caribbean Netherlands', zhCN: '荷兰加勒比区', de: 'Karibische Niederlande' },
  { code: 'CAYMAN_ISLANDS', en: 'Cayman Islands', zhCN: '开曼群岛', de: 'Kaimaninseln' },
  { code: 'CENTRAL_AFRICAN_REPUBLIC', en: 'Central African Republic', zhCN: '中非共和国', de: 'Zentralafrikanische Republik' },
  { code: 'CHAD', en: 'Chad', zhCN: '乍得', de: 'Tschad' },
  { code: 'CHILE', en: 'Chile', zhCN: '智利', de: 'Chile' },
  { code: 'CHINA', en: 'China', zhCN: '中国', de: 'China' },
  { code: 'CHRISTMAS_ISLAND', en: 'Christmas Island', zhCN: '圣诞岛', de: 'Weihnachtsinsel' },
  { code: 'COCOS_KEELING_ISLANDS', en: 'Cocos (Keeling) Islands', zhCN: '科科斯群岛', de: 'Kokosinseln' },
  { code: 'COLOMBIA', en: 'Colombia', zhCN: '哥伦比亚', de: 'Kolumbien' },
  { code: 'COMOROS', en: 'Comoros', zhCN: '科摩罗', de: 'Komoren' },
  { code: 'CONGO_BRAZZAVILLE', en: 'Congo (Brazzaville)', zhCN: '刚果（布）', de: 'Kongo (Brazzaville)' },
  { code: 'CONGO_KINSHASA', en: 'Congo (Kinshasa)', zhCN: '刚果（金）', de: 'Kongo (Kinshasa)' },
  { code: 'COOK_ISLANDS', en: 'Cook Islands', zhCN: '库克群岛', de: 'Cookinseln' },
  { code: 'COSTA_RICA', en: 'Costa Rica', zhCN: '哥斯达黎加', de: 'Costa Rica' },
  { code: 'COTE_D_IVOIRE', en: 'Côte d\'Ivoire', zhCN: '科特迪瓦', de: 'Elfenbeinküste' },
  { code: 'CROATIA', en: 'Croatia', zhCN: '克罗地亚', de: 'Kroatien' },
  { code: 'CUBA', en: 'Cuba', zhCN: '古巴', de: 'Kuba' },
  { code: 'CURACAO', en: 'Curaçao', zhCN: '库拉索', de: 'Curaçao' },
  { code: 'CYPRUS', en: 'Cyprus', zhCN: '塞浦路斯', de: 'Zypern' },
  { code: 'CZECHIA', en: 'Czechia', zhCN: '捷克', de: 'Tschechien' },
  { code: 'DENMARK', en: 'Denmark', zhCN: '丹麦', de: 'Dänemark' },
  { code: 'DJIBOUTI', en: 'Djibouti', zhCN: '吉布提', de: 'Dschibuti' },
  { code: 'DOMINICA', en: 'Dominica', zhCN: '多米尼克', de: 'Dominica' },
  { code: 'DOMINICAN_REPUBLIC', en: 'Dominican Republic', zhCN: '多米尼加共和国', de: 'Dominikanische Republik' },
  { code: 'ECUADOR', en: 'Ecuador', zhCN: '厄瓜多尔', de: 'Ecuador' },
  { code: 'EGYPT', en: 'Egypt', zhCN: '埃及', de: 'Ägypten' },
  { code: 'EL_SALVADOR', en: 'El Salvador', zhCN: '萨尔瓦多', de: 'El Salvador' },
  { code: 'EQUATORIAL_GUINEA', en: 'Equatorial Guinea', zhCN: '赤道几内亚', de: 'Äquatorialguinea' },
  { code: 'ERITREA', en: 'Eritrea', zhCN: '厄立特里亚', de: 'Eritrea' },
  { code: 'ESTONIA', en: 'Estonia', zhCN: '爱沙尼亚', de: 'Estland' },
  { code: 'ESWATINI', en: 'Eswatini', zhCN: '斯威士兰', de: 'Eswatini' },
  { code: 'ETHIOPIA', en: 'Ethiopia', zhCN: '埃塞俄比亚', de: 'Äthiopien' },
  { code: 'FALKLAND_ISLANDS', en: 'Falkland Islands', zhCN: '福克兰群岛', de: 'Falklandinseln' },
  { code: 'FAROE_ISLANDS', en: 'Faroe Islands', zhCN: '法罗群岛', de: 'Färöer' },
  { code: 'FIJI', en: 'Fiji', zhCN: '斐济', de: 'Fidschi' },
  { code: 'FINLAND', en: 'Finland', zhCN: '芬兰', de: 'Finnland' },
  { code: 'FRANCE', en: 'France', zhCN: '法国', de: 'Frankreich' },
  { code: 'FRENCH_GUIANA', en: 'French Guiana', zhCN: '法属圭亚那', de: 'Französisch-Guayana' },
  { code: 'FRENCH_POLYNESIA', en: 'French Polynesia', zhCN: '法属波利尼西亚', de: 'Französisch-Polynesien' },
  { code: 'FRENCH_SOUTHERN_TERRITORIES', en: 'French Southern Territories', zhCN: '法属南部领地', de: 'Französische Süd- und Antarktisgebiete' },
  { code: 'GABON', en: 'Gabon', zhCN: '加蓬', de: 'Gabun' },
  { code: 'GAMBIA', en: 'Gambia', zhCN: '冈比亚', de: 'Gambia' },
  { code: 'GEORGIA', en: 'Georgia', zhCN: '格鲁吉亚', de: 'Georgien' },
  { code: 'GERMANY', en: 'Germany', zhCN: '德国', de: 'Deutschland' },
  { code: 'GHANA', en: 'Ghana', zhCN: '加纳', de: 'Ghana' },
  { code: 'GIBRALTAR', en: 'Gibraltar', zhCN: '直布罗陀', de: 'Gibraltar' },
  { code: 'GREECE', en: 'Greece', zhCN: '希腊', de: 'Griechenland' },
  { code: 'GREENLAND', en: 'Greenland', zhCN: '格陵兰', de: 'Grönland' },
  { code: 'GRENADA', en: 'Grenada', zhCN: '格林纳达', de: 'Grenada' },
  { code: 'GUADELOUPE', en: 'Guadeloupe', zhCN: '瓜德罗普', de: 'Guadeloupe' },
  { code: 'GUAM', en: 'Guam', zhCN: '关岛', de: 'Guam' },
  { code: 'GUATEMALA', en: 'Guatemala', zhCN: '危地马拉', de: 'Guatemala' },
  { code: 'GUERNSEY', en: 'Guernsey', zhCN: '根西岛', de: 'Guernsey' },
  { code: 'GUINEA', en: 'Guinea', zhCN: '几内亚', de: 'Guinea' },
  { code: 'GUINEA_BISSAU', en: 'Guinea-Bissau', zhCN: '几内亚比绍', de: 'Guinea-Bissau' },
  { code: 'GUYANA', en: 'Guyana', zhCN: '圭亚那', de: 'Guyana' },
  { code: 'HAITI', en: 'Haiti', zhCN: '海地', de: 'Haiti' },
  { code: 'HEARD_AND_MCDONALD_ISLANDS', en: 'Heard & McDonald Islands', zhCN: '赫德岛和麦克唐纳群岛', de: 'Heard und McDonaldinseln' },
  { code: 'HONDURAS', en: 'Honduras', zhCN: '洪都拉斯', de: 'Honduras' },
  { code: 'HONG_KONG_SAR_CHINA', en: 'Hong Kong SAR China', zhCN: '中国香港特别行政区', de: 'Hongkong SAR China' },
  { code: 'HUNGARY', en: 'Hungary', zhCN: '匈牙利', de: 'Ungarn' },
  { code: 'ICELAND', en: 'Iceland', zhCN: '冰岛', de: 'Island' },
  { code: 'INDIA', en: 'India', zhCN: '印度', de: 'Indien' },
  { code: 'INDONESIA', en: 'Indonesia', zhCN: '印度尼西亚', de: 'Indonesien' },
  { code: 'IRAN', en: 'Iran', zhCN: '伊朗', de: 'Iran' },
  { code: 'IRAQ', en: 'Iraq', zhCN: '伊拉克', de: 'Irak' },
  { code: 'IRELAND', en: 'Ireland', zhCN: '爱尔兰', de: 'Irland' },
  { code: 'ISLE_OF_MAN', en: 'Isle of Man', zhCN: '马恩岛', de: 'Isle of Man' },
  { code: 'ISRAEL', en: 'Israel', zhCN: '以色列', de: 'Israel' },
  { code: 'ITALY', en: 'Italy', zhCN: '意大利', de: 'Italien' },
  { code: 'JAMAICA', en: 'Jamaica', zhCN: '牙买加', de: 'Jamaika' },
  { code: 'JAPAN', en: 'Japan', zhCN: '日本', de: 'Japan' },
  { code: 'JERSEY', en: 'Jersey', zhCN: '泽西岛', de: 'Jersey' },
  { code: 'JORDAN', en: 'Jordan', zhCN: '约旦', de: 'Jordanien' },
  { code: 'KAZAKHSTAN', en: 'Kazakhstan', zhCN: '哈萨克斯坦', de: 'Kasachstan' },
  { code: 'KENYA', en: 'Kenya', zhCN: '肯尼亚', de: 'Kenia' },
  { code: 'KIRIBATI', en: 'Kiribati', zhCN: '基里巴斯', de: 'Kiribati' },
  { code: 'KUWAIT', en: 'Kuwait', zhCN: '科威特', de: 'Kuwait' },
  { code: 'KYRGYZSTAN', en: 'Kyrgyzstan', zhCN: '吉尔吉斯斯坦', de: 'Kirgisistan' },
  { code: 'LAOS', en: 'Laos', zhCN: '老挝', de: 'Laos' },
  { code: 'LATVIA', en: 'Latvia', zhCN: '拉脱维亚', de: 'Lettland' },
  { code: 'LEBANON', en: 'Lebanon', zhCN: '黎巴嫩', de: 'Libanon' },
  { code: 'LESOTHO', en: 'Lesotho', zhCN: '莱索托', de: 'Lesotho' },
  { code: 'LIBERIA', en: 'Liberia', zhCN: '利比里亚', de: 'Liberia' },
  { code: 'LIBYA', en: 'Libya', zhCN: '利比亚', de: 'Libyen' },
  { code: 'LIECHTENSTEIN', en: 'Liechtenstein', zhCN: '列支敦士登', de: 'Liechtenstein' },
  { code: 'LITHUANIA', en: 'Lithuania', zhCN: '立陶宛', de: 'Litauen' },
  { code: 'LUXEMBOURG', en: 'Luxembourg', zhCN: '卢森堡', de: 'Luxemburg' },
  { code: 'MACAO_SAR_CHINA', en: 'Macao SAR China', zhCN: '中国澳门特别行政区', de: 'Macao SAR China' },
  { code: 'MADAGASCAR', en: 'Madagascar', zhCN: '马达加斯加', de: 'Madagaskar' },
  { code: 'MALAWI', en: 'Malawi', zhCN: '马拉维', de: 'Malawi' },
  { code: 'MALAYSIA', en: 'Malaysia', zhCN: '马来西亚', de: 'Malaysia' },
  { code: 'MALDIVES', en: 'Maldives', zhCN: '马尔代夫', de: 'Malediven' },
  { code: 'MALI', en: 'Mali', zhCN: '马里', de: 'Mali' },
  { code: 'MALTA', en: 'Malta', zhCN: '马耳他', de: 'Malta' },
  { code: 'MARSHALL_ISLANDS', en: 'Marshall Islands', zhCN: '马绍尔群岛', de: 'Marshallinseln' },
  { code: 'MARTINIQUE', en: 'Martinique', zhCN: '马提尼克', de: 'Martinique' },
  { code: 'MAURITANIA', en: 'Mauritania', zhCN: '毛里塔尼亚', de: 'Mauretanien' },
  { code: 'MAURITIUS', en: 'Mauritius', zhCN: '毛里求斯', de: 'Mauritius' },
  { code: 'MAYOTTE', en: 'Mayotte', zhCN: '马约特', de: 'Mayotte' },
  { code: 'MEXICO', en: 'Mexico', zhCN: '墨西哥', de: 'Mexiko' },
  { code: 'MICRONESIA', en: 'Micronesia', zhCN: '密克罗尼西亚', de: 'Mikronesien' },
  { code: 'MOLDOVA', en: 'Moldova', zhCN: '摩尔多瓦', de: 'Moldau' },
  { code: 'MONACO', en: 'Monaco', zhCN: '摩纳哥', de: 'Monaco' },
  { code: 'MONGOLIA', en: 'Mongolia', zhCN: '蒙古', de: 'Mongolei' },
  { code: 'MONTENEGRO', en: 'Montenegro', zhCN: '黑山', de: 'Montenegro' },
  { code: 'MONTSERRAT', en: 'Montserrat', zhCN: '蒙特塞拉特', de: 'Montserrat' },
  { code: 'MOROCCO', en: 'Morocco', zhCN: '摩洛哥', de: 'Marokko' },
  { code: 'MOZAMBIQUE', en: 'Mozambique', zhCN: '莫桑比克', de: 'Mosambik' },
  { code: 'MYANMAR', en: 'Myanmar', zhCN: '缅甸', de: 'Myanmar' },
  { code: 'NAMIBIA', en: 'Namibia', zhCN: '纳米比亚', de: 'Namibia' },
  { code: 'NAURU', en: 'Nauru', zhCN: '瑙鲁', de: 'Nauru' },
  { code: 'NEPAL', en: 'Nepal', zhCN: '尼泊尔', de: 'Nepal' },
  { code: 'NETHERLANDS', en: 'Netherlands', zhCN: '荷兰', de: 'Niederlande' },
  { code: 'NEW_CALEDONIA', en: 'New Caledonia', zhCN: '新喀里多尼亚', de: 'Neukaledonien' },
  { code: 'NEW_ZEALAND', en: 'New Zealand', zhCN: '新西兰', de: 'Neuseeland' },
  { code: 'NICARAGUA', en: 'Nicaragua', zhCN: '尼加拉瓜', de: 'Nicaragua' },
  { code: 'NIGER', en: 'Niger', zhCN: '尼日尔', de: 'Niger' },
  { code: 'NIGERIA', en: 'Nigeria', zhCN: '尼日利亚', de: 'Nigeria' },
  { code: 'NIUE', en: 'Niue', zhCN: '纽埃', de: 'Niue' },
  { code: 'NORFOLK_ISLAND', en: 'Norfolk Island', zhCN: '诺福克岛', de: 'Norfolkinsel' },
  { code: 'NORTH_KOREA', en: 'North Korea', zhCN: '朝鲜', de: 'Nordkorea' },
  { code: 'NORTH_MACEDONIA', en: 'North Macedonia', zhCN: '北马其顿', de: 'Nordmazedonien' },
  { code: 'NORTHERN_MARIANA_ISLANDS', en: 'Northern Mariana Islands', zhCN: '北马里亚纳群岛', de: 'Nördliche Marianen' },
  { code: 'NORWAY', en: 'Norway', zhCN: '挪威', de: 'Norwegen' },
  { code: 'OMAN', en: 'Oman', zhCN: '阿曼', de: 'Oman' },
  { code: 'PAKISTAN', en: 'Pakistan', zhCN: '巴基斯坦', de: 'Pakistan' },
  { code: 'PALAU', en: 'Palau', zhCN: '帕劳', de: 'Palau' },
  { code: 'PALESTINIAN_TERRITORIES', en: 'Palestinian Territories', zhCN: '巴勒斯坦领土', de: 'Palästinensische Gebiete' },
  { code: 'PANAMA', en: 'Panama', zhCN: '巴拿马', de: 'Panama' },
  { code: 'PAPUA_NEW_GUINEA', en: 'Papua New Guinea', zhCN: '巴布亚新几内亚', de: 'Papua-Neuguinea' },
  { code: 'PARAGUAY', en: 'Paraguay', zhCN: '巴拉圭', de: 'Paraguay' },
  { code: 'PERU', en: 'Peru', zhCN: '秘鲁', de: 'Peru' },
  { code: 'PHILIPPINES', en: 'Philippines', zhCN: '菲律宾', de: 'Philippinen' },
  { code: 'PITCAIRN_ISLANDS', en: 'Pitcairn Islands', zhCN: '皮特凯恩群岛', de: 'Pitcairninseln' },
  { code: 'POLAND', en: 'Poland', zhCN: '波兰', de: 'Polen' },
  { code: 'PORTUGAL', en: 'Portugal', zhCN: '葡萄牙', de: 'Portugal' },
  { code: 'PUERTO_RICO', en: 'Puerto Rico', zhCN: '波多黎各', de: 'Puerto Rico' },
  { code: 'QATAR', en: 'Qatar', zhCN: '卡塔尔', de: 'Katar' },
  { code: 'REUNION', en: 'Réunion', zhCN: '留尼汪', de: 'Réunion' },
  { code: 'ROMANIA', en: 'Romania', zhCN: '罗马尼亚', de: 'Rumänien' },
  { code: 'RUSSIA', en: 'Russia', zhCN: '俄罗斯', de: 'Russland' },
  { code: 'RWANDA', en: 'Rwanda', zhCN: '卢旺达', de: 'Ruanda' },
  { code: 'SAMOA', en: 'Samoa', zhCN: '萨摩亚', de: 'Samoa' },
  { code: 'SAN_MARINO', en: 'San Marino', zhCN: '圣马力诺', de: 'San Marino' },
  { code: 'SAO_TOME_AND_PRINCIPE', en: 'São Tomé & Príncipe', zhCN: '圣多美和普林西比', de: 'São Tomé und Príncipe' },
  { code: 'SAUDI_ARABIA', en: 'Saudi Arabia', zhCN: '沙特阿拉伯', de: 'Saudi-Arabien' },
  { code: 'SENEGAL', en: 'Senegal', zhCN: '塞内加尔', de: 'Senegal' },
  { code: 'SERBIA', en: 'Serbia', zhCN: '塞尔维亚', de: 'Serbien' },
  { code: 'SEYCHELLES', en: 'Seychelles', zhCN: '塞舌尔', de: 'Seychellen' },
  { code: 'SIERRA_LEONE', en: 'Sierra Leone', zhCN: '塞拉利昂', de: 'Sierra Leone' },
  { code: 'SINGAPORE', en: 'Singapore', zhCN: '新加坡', de: 'Singapur' },
  { code: 'SINT_MAARTEN', en: 'Sint Maarten', zhCN: '荷属圣马丁', de: 'Sint Maarten' },
  { code: 'SLOVAKIA', en: 'Slovakia', zhCN: '斯洛伐克', de: 'Slowakei' },
  { code: 'SLOVENIA', en: 'Slovenia', zhCN: '斯洛文尼亚', de: 'Slowenien' },
  { code: 'SOLOMON_ISLANDS', en: 'Solomon Islands', zhCN: '所罗门群岛', de: 'Salomonen' },
  { code: 'SOMALIA', en: 'Somalia', zhCN: '索马里', de: 'Somalia' },
  { code: 'SOUTH_AFRICA', en: 'South Africa', zhCN: '南非', de: 'Südafrika' },
  { code: 'SOUTH_GEORGIA_AND_SOUTH_SANDWICH_ISLANDS', en: 'South Georgia & South Sandwich Islands', zhCN: '南乔治亚和南桑威奇群岛', de: 'Südgeorgien und die Südlichen Sandwichinseln' },
  { code: 'SOUTH_KOREA', en: 'South Korea', zhCN: '韩国', de: 'Südkorea' },
  { code: 'SOUTH_SUDAN', en: 'South Sudan', zhCN: '南苏丹', de: 'Südsudan' },
  { code: 'SPAIN', en: 'Spain', zhCN: '西班牙', de: 'Spanien' },
  { code: 'SRI_LANKA', en: 'Sri Lanka', zhCN: '斯里兰卡', de: 'Sri Lanka' },
  { code: 'ST_BARTHELEMY', en: 'St. Barthélemy', zhCN: '圣巴泰勒米', de: 'St. Barthélemy' },
  { code: 'ST_HELENA', en: 'St. Helena', zhCN: '圣赫勒拿', de: 'St. Helena' },
  { code: 'ST_KITTS_AND_NEVIS', en: 'St. Kitts & Nevis', zhCN: '圣基茨和尼维斯', de: 'St. Kitts und Nevis' },
  { code: 'ST_LUCIA', en: 'St. Lucia', zhCN: '圣卢西亚', de: 'St. Lucia' },
  { code: 'ST_MARTIN', en: 'St. Martin', zhCN: '法属圣马丁', de: 'St. Martin' },
  { code: 'ST_PIERRE_AND_MIQUELON', en: 'St. Pierre & Miquelon', zhCN: '圣皮埃尔和密克隆', de: 'St. Pierre und Miquelon' },
  { code: 'ST_VINCENT_AND_GRENADINES', en: 'St. Vincent & Grenadines', zhCN: '圣文森特和格林纳丁斯', de: 'St. Vincent und die Grenadinen' },
  { code: 'SUDAN', en: 'Sudan', zhCN: '苏丹', de: 'Sudan' },
  { code: 'SURINAME', en: 'Suriname', zhCN: '苏里南', de: 'Suriname' },
  { code: 'SVALBARD_AND_JAN_MAYEN', en: 'Svalbard & Jan Mayen', zhCN: '斯瓦尔巴和扬马延', de: 'Svalbard und Jan Mayen' },
  { code: 'SWEDEN', en: 'Sweden', zhCN: '瑞典', de: 'Schweden' },
  { code: 'SWITZERLAND', en: 'Switzerland', zhCN: '瑞士', de: 'Schweiz' },
  { code: 'SYRIA', en: 'Syria', zhCN: '叙利亚', de: 'Syrien' },
  { code: 'TAIWAN_PROVINCE_CHINA', en: 'Taiwan, Province of China', zhCN: '中国台湾省', de: 'Taiwan, Provinz Chinas' },
  { code: 'TAJIKISTAN', en: 'Tajikistan', zhCN: '塔吉克斯坦', de: 'Tadschikistan' },
  { code: 'TANZANIA', en: 'Tanzania', zhCN: '坦桑尼亚', de: 'Tansania' },
  { code: 'THAILAND', en: 'Thailand', zhCN: '泰国', de: 'Thailand' },
  { code: 'TIMOR_LESTE', en: 'Timor-Leste', zhCN: '东帝汶', de: 'Timor-Leste' },
  { code: 'TOGO', en: 'Togo', zhCN: '多哥', de: 'Togo' },
  { code: 'TOKELAU', en: 'Tokelau', zhCN: '托克劳', de: 'Tokelau' },
  { code: 'TONGA', en: 'Tonga', zhCN: '汤加', de: 'Tonga' },
  { code: 'TRINIDAD_AND_TOBAGO', en: 'Trinidad & Tobago', zhCN: '特立尼达和多巴哥', de: 'Trinidad und Tobago' },
  { code: 'TUNISIA', en: 'Tunisia', zhCN: '突尼斯', de: 'Tunesien' },
  { code: 'TURKEY', en: 'Turkey', zhCN: '土耳其', de: 'Türkei' },
  { code: 'TURKMENISTAN', en: 'Turkmenistan', zhCN: '土库曼斯坦', de: 'Turkmenistan' },
  { code: 'TURKS_AND_CAICOS_ISLANDS', en: 'Turks & Caicos Islands', zhCN: '特克斯和凯科斯群岛', de: 'Turks- und Caicosinseln' },
  { code: 'TUVALU', en: 'Tuvalu', zhCN: '图瓦卢', de: 'Tuvalu' },
  { code: 'UGANDA', en: 'Uganda', zhCN: '乌干达', de: 'Uganda' },
  { code: 'UKRAINE', en: 'Ukraine', zhCN: '乌克兰', de: 'Ukraine' },
  { code: 'UNITED_ARAB_EMIRATES', en: 'United Arab Emirates', zhCN: '阿联酋', de: 'Vereinigte Arabische Emirate' },
  { code: 'UNITED_KINGDOM', en: 'United Kingdom', zhCN: '英国', de: 'Vereinigtes Königreich' },
  { code: 'UNITED_STATES', en: 'United States', zhCN: '美国', de: 'Vereinigte Staaten' },
  { code: 'URUGUAY', en: 'Uruguay', zhCN: '乌拉圭', de: 'Uruguay' },
  { code: 'US_OUTLYING_ISLANDS', en: 'U.S. Outlying Islands', zhCN: '美国本土外小岛屿', de: 'Amerikanische Überseeinseln' },
  { code: 'US_VIRGIN_ISLANDS', en: 'U.S. Virgin Islands', zhCN: '美属维尔京群岛', de: 'Amerikanische Jungferninseln' },
  { code: 'UZBEKISTAN', en: 'Uzbekistan', zhCN: '乌兹别克斯坦', de: 'Usbekistan' },
  { code: 'VANUATU', en: 'Vanuatu', zhCN: '瓦努阿图', de: 'Vanuatu' },
  { code: 'VATICAN_CITY', en: 'Vatican City', zhCN: '梵蒂冈', de: 'Vatikanstadt' },
  { code: 'VENEZUELA', en: 'Venezuela', zhCN: '委内瑞拉', de: 'Venezuela' },
  { code: 'VIETNAM', en: 'Vietnam', zhCN: '越南', de: 'Vietnam' },
  { code: 'WALLIS_AND_FUTUNA', en: 'Wallis & Futuna', zhCN: '瓦利斯和富图纳', de: 'Wallis und Futuna' },
  { code: 'WESTERN_SAHARA', en: 'Western Sahara', zhCN: '西撒哈拉', de: 'Westsahara' },
  { code: 'YEMEN', en: 'Yemen', zhCN: '也门', de: 'Jemen' },
  { code: 'ZAMBIA', en: 'Zambia', zhCN: '赞比亚', de: 'Sambia' },
  { code: 'ZIMBABWE', en: 'Zimbabwe', zhCN: '津巴布韦', de: 'Simbabwe' }
]